import { render, staticRenderFns } from "./ExternalFissionActivity.vue?vue&type=template&id=5fd1a748&"
import script from "./ExternalFissionActivity.vue?vue&type=script&lang=ts&"
export * from "./ExternalFissionActivity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports